var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toggle-content",class:{ 'toggle-active': _vm.value },on:{"click":_vm.switchValue}},[_c('div',{staticClass:"toggle-content__icon"}),_c('div',{staticClass:"toggle-content__text"},[_vm._v(_vm._s(_vm.toggleText))])])}
var staticRenderFns = []

export { render, staticRenderFns }